// client/src/services/leaveService.js
import API from "../api/client";

export const leaveService = {
  // Correctly matches router.post("/request", ...)
  submitRequest: (data) => API.post("/leave/request", data),

  // Correctly matches router.get("/summary", ...)
  getSummary: () => API.get("/leave/summary"),

  // Correctly matches router.get("/my-leaves", ...)
  getMyLeaves: () => API.get("/leave/my-leaves"),

  // Correctly matches router.patch("/hr-action", ...)
  updateHrAction: (data) => API.patch("/leave/hr-action", data),

  // Correctly matches router.patch("/manager-action", ...)
  updateManagerAction: (data) => API.patch("/leave/manager-action", data),
};
